import { FC, useEffect, useState } from 'react';

interface RangeSliderType {
    min: string;
    max: string;
    step: string;
    marks: MarkType[];
    valueLabelFormat: () => void;
    onChange: () => void;
    value: string;
}

export interface MarkType {
    key: string;
    value: string;
}

const RangeSlider: FC<RangeSliderType> = ({ min, max, marks, onChange, value }) => {
    const [selectedValue, setValue] = useState(
        marks?.find((item) => item.key === value)?.value ?? 1,
    );

    useEffect(() => {
        if (marks?.length > 0 && !value) {
            // onChange(marks?.[0]?.key);
        } else if (marks?.length > 0 && value) {
            setValue(marks?.find((item) => item.key === value)?.value ?? 1);
        }
    }, [marks, value, onChange]);

    // const changeValue = (event, value) => {
    //     const key = marks?.find((item) => item.value === value)?.key;
    //     onChange(key);
    // };

    const setClassName = () => {
        if (selectedValue === min) {
            return 'first';
        }
        if (selectedValue === max) {
            return 'last';
        }
        return '';
    };

    return (
        <div className={setClassName()}>
            {/* <Slider
                style={{ width: '94%' }}
                valueLabelDisplay="auto"
                valueLabelFormat={valueLabelFormat}
                min={min}
                max={max}
                step={step}
                value={selectedValue}
                marks={marks}
                onChange={changeValue}
            /> */}
        </div>
    );
};

export default RangeSlider;
